module.exports = __webpack_public_path__ + "media/Arrow_Cranbourne.3a8ffa93.svg";